import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { QueryResult } from "@/api/utils/types"
import { WarrantsCommunicationGroupParser } from "@/models/admin/warrantsCommunicationGroup/warrantsCommunicationGroup.parser"
import { IWarrantsCommunicationGroup } from "@/models/admin/warrantsCommunicationGroup/warrantsCommunicationGroup.types"
import {
  Financials_Warrants_Communication_Group_Bool_Exp,
  Financials_Warrants_Communication_Group_Order_By,
  GetWarrantsCommunicationGroupsQuery,
} from "@/api/hasura/generated/graphql"

export interface WarrantsCommunicationGroupListResult {
  groups: IWarrantsCommunicationGroup[]
  totalCount: number
}

class WarrantsCommunicationGroupServiceClass {
  getGroups(
    accountNumber: string,
    page: number,
    pageSize: number,
    orderBy: Financials_Warrants_Communication_Group_Order_By,
  ): QueryResult<WarrantsCommunicationGroupListResult> {
    const where: Financials_Warrants_Communication_Group_Bool_Exp = {
      account_number: { _eq: accountNumber },
    }

    return useQuery({
      ...HasuraQueries.warrants.communicationGroups(
        (page - 1) * pageSize,
        pageSize,
        where,
        orderBy,
      ),
      useRawResponse: true,
      placeholderData: { groups: [], totalCount: 0 },
      parserFn: (
        data: GetWarrantsCommunicationGroupsQuery,
      ): WarrantsCommunicationGroupListResult => ({
        groups: data.financials_warrants_communication_group.map(
          WarrantsCommunicationGroupParser.toDomain,
        ),
        totalCount:
          data.financials_warrants_communication_group_aggregate.aggregate
            ?.count ?? 0,
      }),
    })
  }
}

export const WarrantsCommunicationGroupService =
  new WarrantsCommunicationGroupServiceClass()
